import React from 'react';
import PageNavControls from 'components/PageNavControls';
import { IProps, IState } from './types';
import commonService from 'utils/commonService';
import { Article } from 'bff/models/new/article';
import newListService from 'bff/services/newListService';
// import moment from 'moment';
import moment from 'moment-timezone';
import { RouterSettings } from 'constants/models/routerSettings';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';

class NewsArticle extends React.Component<IProps, IState> {
  componentDidMount () {
    // 頁面初始取得傳入的部落格文章
    if (!storageService.getItem(storageKeys.NewsDetail)) {
      this.props.history.goBack();
      return;
    }

    const articleInfo = JSON.parse(storageService.getItem(storageKeys.NewsDetail)) as Article;

    this.setState({ articleInfo: articleInfo });
  }

  componentDidUpdate () {
    // 內容資料有更動，移至畫面上方
    commonService.scrollToTop();
  }

  componentWillUnmount () {
    // 頁面關閉，暫存明細資料
    storageService.removeItem(storageKeys.NewsDetail);
    storageService.setItem(storageKeys.NewsDetail, JSON.stringify(this.state.articleInfo));
  }

  render () {
    /**
   * @description 點選上下一則的事件
  */
    const handleNextPrevClick = async (sn: number) => {
      if (!sn) return;
      const articleInfo = await newListService.fetchArticle(sn);
      if (!articleInfo) return;

      storageService.removeItem(storageKeys.NewsDetail);
      storageService.setItem(storageKeys.NewsDetail, JSON.stringify(articleInfo));
      this.setState({ articleInfo: articleInfo });
    };

    return this.state && this.state.articleInfo && (
      <div className="news-article">
        <div className="template-container">
          <div className="template-content">
            <div className="news-article__header">
              <div className="news-article__period">
                <span>更新日期：{moment(this.state.articleInfo.CREATE_TIME).format('YYYY/MM/DD')}</span>
              </div>
              <div className="news-article__title">{this.state.articleInfo.TITLE}</div>
            </div>
            <div
              className="news-article__cover-photo" style={{
                backgroundImage: `url(${this.state.articleInfo.IMAGE_URL.length > 0 ? this.state.articleInfo.IMAGE_URL[0] : ''})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center'
              }}
            />
            <div className="news-article__content">
              <p>{commonService.htmlParser(this.state.articleInfo.CONTENT)}</p>
              <p>詳細內文來源：
                <a className="element__link" href={this.state.articleInfo.SRC_URL} target="_blank" rel="noopener noreferrer">{this.state.articleInfo.SRC_URL}</a>
              </p>
            </div>
          </div>
        </div>
        {/* 頁面導航控制項 */}
        <PageNavControls
          prevBtnLink="/"
          onPrevClick={() => handleNextPrevClick(this.state.articleInfo.PREV_SN)}
          nextBtnLink="/"
          onNextClick={() => handleNextPrevClick(this.state.articleInfo.NEXT_SN)}
          navBtnLink={RouterSettings.News.List}
          navBtnText="回最新消息頁"
          prevSN={this.state.articleInfo.PREV_SN}
          nextSN={this.state.articleInfo.NEXT_SN}
        />
      </div>
    );
  }
};

export default NewsArticle;
